import React, { memo } from 'react';
import { AnalyticsProvider } from '../Analytics/analytics-context';
import { AnalyticsFilterBar } from '../Analytics/components/analytics-filter-bar';
import GaIntegrationForm from '../Analytics/components/ga-integration-form';
import GaOverview from '../Analytics/components/ga-overview';
import GaTrend from '../Analytics/components/ga-trend';
import GaSources from '../Analytics/components/ga-sources';
import GaDemographics from '../Analytics/components/ga-demographics';
import GaTopPages from '../Analytics/components/ga-top-pages';
import GaCountryChart from '../Analytics/components/ga-country-chart';
import GaDeviceChart from '../Analytics/components/ga-device-chart';
import GaActiveUsers from '../Analytics/components/ga-active-users';

interface Props {}

export const DashboardGAAnalytics = memo((props: Props) => {
  return (
    <AnalyticsProvider>
      <div className="space-y-6">
        <AnalyticsFilterBar />
        <GaOverview />
        <div className="grid gap-6 xl:grid-cols-2">
          <GaTrend />
          <GaCountryChart />
        </div>
        <div className="grid gap-6 xl:grid-cols-2">
        <GaDemographics />
          <GaDeviceChart />
        </div>
        <GaActiveUsers />
        <div className="grid gap-6 xl:grid-cols-2">
          <GaSources />
          <GaTopPages />
        </div>
        <GaIntegrationForm />
      </div>
    </AnalyticsProvider>
  );
});
